import { Typography, Container, ListItem, List, ListItemIcon, ListItemText, Divider, CardActionArea, Card, Grid, Box, } from "@mui/material";
import NextBreadcrumbs from "../../component/NextBreadcrumbs";
import Page from "../../component/Page";
import BookIcon from '@mui/icons-material/Book';
import ArticleIcon from '@mui/icons-material/Article';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import React from "react";

const CardButton = ({ label, icon, href }) => {
  return <Card >
    <CardActionArea sx={{ width: 350, height: 300, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }} href={href}>
      {icon}
      <Typography variant="h4">{label}</Typography>
    </CardActionArea>
  </Card>
}

const Researches = ({ data }) => {
  const thesesList = [];
  const theses = data?.theses;
  for (const year in theses) {
    thesesList.push(
      <List dense>
        {theses[year].map(
          (i, idx) =>
            <React.Fragment>
              {idx > 0 &&
                <Divider component="li" />
              }
              <ListItem key={`${year}_${i}`}>
                <ListItemIcon>
                  <ArticleIcon />
                </ListItemIcon>
                <ListItemText sx={{ fontSize: 10 }}>
                  {i}
                </ListItemText>
              </ListItem>
            </React.Fragment>
        )}
      </List>
    )
  }

  return (
    <Page>
      <Container sx={{ py: 10 }}>
        <NextBreadcrumbs></NextBreadcrumbs>
        <Typography variant="h3">Research</Typography>
        <Typography variant="body1" sx={{ textAlign: "justify", py: 3 }}>
          The Kentucky Climate Center (KCC) has an established research program that provides opportunities for both undergraduate and graduate students. The Climate Research Lab and WKU’s High Performance Computing Center support meso-scale modeling with an emphasis on land-atmosphere interactions. The Kentucky Mesonet data archive is a rich resource for spatial and temporal analysis of near-surface meteorological and climatological phenomena. Applied research opportunities exist to develop and offer climate services in support of KCC’s role as the State Climate Office for Kentucky.
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: "wrap", justifyContent: "start" }}>
          <Box sx={{ m: 1 }}>
            <CardButton label="Publication" icon={<BookIcon sx={{ fontSize: 150 }}></BookIcon>} href="/research/publication"></CardButton>
          </Box>
        </Box>
      </Container>
    </Page >
  );
};

export default Researches;
